import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskOffice2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="desk-office-2"><path d="M5.75 3.75H14.25V9.25H5.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 9.5V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.75 16H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 20.25V11.75H13M13 11.75H20.25V20.25H13V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDeskOffice2;
